
import { config, useTrail, useTransition } from '@react-spring/core';
import { animated } from '@react-spring/web';
import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router';
import { useAuth } from '../../context/AuthContext';
import { useBoltData } from '../../context/TutorBoltDataContext';
import { database } from '../../firebase'
import { MoSpan, MoContainer, MoLink, Input, Button, ButtonTypes, Alert, MoModal } from '../../Mo7/mo7UI'
import { cols, icons } from '../../services/design.sevice';
import Fade from 'react-reveal/Fade';


export default function Home() {
    const [{ subject, tutoringAdress }, setInputValues] = useState({
        subject: "", tutoringAdress: ""
    })
    const [{ isOpenSubjectList, isOpenLocationList, helperShownSubjects, helperShownLocations }, setInputHelper] = useState({ helperShownLocations: [], helperShownSubjects: [], isOpenSubjectList: false, isOpenLocationList: false })

    const [message, setMessage] = useState("")

    const [results, setResults] = useState([])
    const refSearchResultContainer = useRef()
    const refTopPage = useRef()
    const refHowItWorks = useRef()
    const history = useHistory()
    const { currentUser } = useAuth()
    const { subjectList, locationList } = useBoltData()
    const [showModal, setShowModal] = useState(false)

    // const [width] = useWindowSize()
    // let isMobile = width < 980;

    function scrollToTopPage() {
        refTopPage?.current.scrollIntoView({
            behavior: "smooth"
        })
    }
    function handleSearch(e) {
        e.preventDefault()
        if (subject.trim().length <= 0 || tutoringAdress.trim().length <= 0) {
            return console.log("Please fill in stuff");
        }

        //get from database
        database.announcements.where("subject", "==", subject)
            .where("tutoringAdress", "==", tutoringAdress)
            .where("isOnline", "==", true)
            .onSnapshot(snapshot => {
                setResults(snapshot.docs.map(database.formattedDoc))
                if (snapshot.docs?.length > 0) {
                    refSearchResultContainer?.current?.scrollIntoView({
                        behavior: "smooth"
                    })
                } else {
                    setShowModal(true)
                }
            })

    }
    function handleSearchBySubject(subject) {
        //get from database
        database.announcements.where("subject", "==", subject)
            .where("isOnline", "==", true)
            .onSnapshot(snapshot => {
                setResults(snapshot.docs.map(database.formattedDoc))
                if (snapshot.docs?.length > 0) {
                    refSearchResultContainer?.current?.scrollIntoView({
                        behavior: "smooth"
                    })
                } else {
                    setShowModal(true)
                }
            })

    }
    function handleSearchByLocation(tutoringAdress) {
        //get from database
        database.announcements.where("tutoringAdress", "==", tutoringAdress)
            .where("isOnline", "==", true)
            .onSnapshot(snapshot => {
                setResults(snapshot.docs.map(database.formattedDoc))
                if (snapshot.docs?.length > 0) {
                    refSearchResultContainer?.current?.scrollIntoView({
                        behavior: "smooth"
                    })
                } else {
                    setShowModal(true)
                }
            })

    }
    async function handleSearchByPrice(min, max) {
        //get from database
        try {

            await database.announcements
                .where("price", ">=", min)
                .where("price", "<", max)
                .where("isOnline", "==", true)
                .onSnapshot(snapshot => {
                    setResults(snapshot.docs.map(database.formattedDoc))
                    if (snapshot.docs?.length > 0) {
                        refSearchResultContainer?.current?.scrollIntoView({
                            behavior: "smooth"
                        })
                    } else {
                        setShowModal(true)
                    }
                })
        } catch (e) {
            console.log(e)
        }


    }


    function scrollToHowItWorkd() {

        refHowItWorks?.current?.scrollIntoView({
            behavior: "smooth"
        })
    }
    function handleOnchangeSearch(e) {
        const { name, value } = e.target;

        setInputValues(prev => ({
            ...prev, [name]: value
        }))
    }
    function handleSelectAnnouncement(path) {

        if (!currentUser) {
            setMessage("You need to sign in")
            return
        }

        history.push(path)
    }

    //#region  
    const domSubjects = Object.entries(subjectList).map(arr => {
        return <MoSpan key={arr[0]} cursor="pointer" fs_sml onClick={function () { handleSearchBySubject(arr[0]) }} > {arr[0]} </MoSpan>
    })
    const domLocations = Object.entries(locationList).map(arr => {
        return <MoSpan key={arr[0]} cursor="pointer" fs_sml onClick={function () { handleSearchByLocation(arr[0]) }} > {arr[0]} </MoSpan>
    })
    const anim_searchResults = useTrail(results.length, {
        from: {
            x: -80,
            opacity: 0
        },
        to: {
            opacity: 1,
            x: 0,

        },
        config: config.molasses

    })
    const domSearchResults = results.map((r, i) => {
        return <animated.div style={anim_searchResults[i]} key={i} > <MoContainer onClick={function () { handleSelectAnnouncement(`/announcement/${r.id}`) }}>
            <MoContainer cursor='pointer' bg={cols.mainLight_2} align="center" eff_shdw={{ op: .3, sprd: "1rem", dur: .3 }} b_r={{ all: ".5rem" }} flex flex_dir_c min_h="25rem" pd={{ t: '1rem' }} w="15rem">
                <MoContainer eff_size={{ val: 1.2, dur: .3 }} b_r={{ all: ".5rem" }} bg="white" h="13rem" w="13rem" bg_i={r.photoURL} />
                <MoContainer w="100%" flex m_t="10px" flex_dir_c>
                    <MoSpan pd={{ l: "20px" }} col={cols.mainDark_2} w="85%" fs_mid f_w="600"> {r?.displayName} </MoSpan>
                    <MoSpan pd={{ l: "20px" }} col={cols.mainDark_2} fs_sml f_w="500"> {r?.headline}  </MoSpan>
                </MoContainer>
                <MoContainer w="90%" flex flex_dir_c m_t="10px" justify='space-around' pd={{ b: "1rem" }}>
                    <MoSpan col={cols.mainLight_4} b_r={{ all: "2rem" }} f_size="1.2rem" f_w="600" pd={{ tb: ".5rem", lr: "2rem" }} bg={cols.main_blue} >
                        📚 {r.subject} </MoSpan>
                    <MoSpan col={cols.mainLight_4} b_r={{ all: "2rem" }} f_size="1.2rem" f_w="600" pd={{ tb: ".5rem", lr: "2rem" }} bg={cols.green} >
                        📍 {r.tutoringAdress} </MoSpan>
                    <MoSpan col={cols.mainLight_4} b_r={{ all: "2rem" }} f_size="1.2rem" f_w="600" pd={{ tb: ".5rem", lr: "2rem" }} bg={cols.main_purple} >
                        💵 {r?.price} $/h </MoSpan>
                </MoContainer>
            </MoContainer>
        </MoContainer ></animated.div>
    })
    function handleInputSubjectHelper() {
        const arr = []
        for (let ele of Object.entries(subjectList)) {
            if (ele[0].toLowerCase().includes(subject.toLowerCase())) arr.push(ele[0])
            if (arr.length > 5) break

        }
        setInputHelper(prev => ({
            ...prev, "helperShownSubjects": arr
        }))
    }
    function handleInputLocationHelper() {
        const arr = []
        for (let ele of Object.entries(locationList)) {
            if (ele[0].toLowerCase().includes(tutoringAdress.toLowerCase())) arr.push(ele[0])
            if (arr.length > 5) break
        }
        setInputHelper(prev => ({
            ...prev, "helperShownLocations": arr
        }))
    }
    const domHelperInputSubject = helperShownSubjects.map((ele, i) => {
        return (
            <MoSpan key={i + "2d"} onClick={function () { handleOnchangeSearch({ target: { name: "subject", value: ele } }) }}
                fs_sml col={cols.mainDark_black} eff_hvr={`color:${cols.main_blue};cursor:pointer;font-weight:bold;`}
                pd={{ tb: "10px" }}> {ele} </MoSpan>
        )
    })
    const domHelperInputLocation = helperShownLocations.map((ele, i) => {
        return (
            <MoSpan key={i + "1d"} onClick={function () { handleOnchangeSearch({ target: { name: "tutoringAdress", value: ele } }) }}
                fs_sml col={cols.mainDark_black} eff_hvr={`color:${cols.main_blue};cursor:pointer;font-weight:bold;`}
                pd={{ tb: "10px" }}> {ele} </MoSpan>
        )
    })
    //#endregion

    //#region animations


    const anim_landingPage = useTrail(5, {
        from: {
            y: -50,
            opacity: 0
        },
        to: {
            y: 0,
            opacity: 1
        }
    })

    const anim_inputHelperSubject = useTransition(isOpenSubjectList, {
        from: { opacity: 0, },
        enter: { opacity: 1, },
        leave: { opacity: 0, },

        delay: 200,
        config: config.default,
    })
    const anim_inputHelperLocation = useTransition(isOpenLocationList, {
        from: { opacity: 0, },
        enter: { opacity: 1, },
        leave: { opacity: 0, },

        delay: 200,
        config: config.default,
    })

    const anim_modal = useTransition(showModal, {
        from: { opacity: 0, },
        enter: { opacity: 1, },
        leave: { opacity: 0, },
       delay:2000,
        config: config.gentle,
    })

    //#endregion

    return (
        <MoContainer pos="relative" flow_y='scroll' flow_x="hidden" h="100vh" scroller>
            {message.length > 0 && <MoContainer w="100%" z="10" flex align="center" justify="center" pos="fixed" pos_dir={{ b: "2rem" }}>
                <Alert info w="60%" >  You need To SignIn </Alert>
                <Alert success w="10%" onClick={function () { history.push("/signin") }}>  Ok </Alert>
                <Alert danger w="10%" onClick={function () { setMessage("") }}>  Cancel </Alert>
            </MoContainer>}

            {/* Modal */}
            { anim_modal(
                (styles, item) => item && <animated.div style={styles} >
                    <MoModal m_t="-25%" buttonText={{ ok: "Ok" }} err_message=" No Results Were Found 😔" onClose={function () { setShowModal(false) }} onOk={function () { setShowModal(false) }} />
                </animated.div>
            )}

            {/* Demo */}
            {/* { isMobile &&
                <MoContainer trfm="translateX(50vw)" demo pos="fixed" z="10" >
                    <MoSpan fs_sml col={cols.red} bg={cols.mainDark_2} > Mobile </MoSpan>
                </MoContainer>
            } */}
            {/* background decorations */}
            <MoContainer b_r={{ bl: "257px" }} pos_dir={{ r: 0 }} z="-2" pos="absolute" w="71vw" br h="80vh" bg={cols.mainLight_1} />
            <MoContainer b_r={{ tr: "257px" }} pos_dir={{ t: "100vh" }} z="-2" pos="absolute" w="70vw" br h="80vh" bg={cols.mainLight_1} />
            <MoContainer flow="hidden" b_r={{ bl: "257px" }} pos_dir={{ r: 0, l: "45%" }} z="-1" pos="absolute" w="71vw" br h="80vh" >
                <MoContainer grid sdw={{ op: "rgba(0,0,0,0.2)", sprd: '1rem', x: 0, y: 0 }} b_r={{ bl: "5rem", tr: "5rem", tl: "5rem" }} place="center" pos="absolute" bg="white" z="-1" w="12rem" h="4rem" pos_dir={{ t: '20%', l: "12%" }}>
                    <MoSpan fs_sml col={cols.mainDark_1} > Get Better<MoSpan fs_sml f_w="600" col={cols.green} > Grades 🤩</MoSpan>  </MoSpan>
                </MoContainer>
                <img height="400px" style={{ position: "absolute", bottom: 0, left: "10%" }} src={icons.img_girl_with_books} alt="" />
            </MoContainer>

            {/* Navigate To Top Page */}
            <MoContainer onClick={scrollToTopPage} grid trfm="rotate(-90deg)" place="center" bg={cols.mainLight_1} eff_shdw={{ op: .3 }} pos="fixed" pos_dir={{ b: "1rem", r: "1.5rem" }} w="2rem" h="2rem" b_r={{ all: "2rem" }} z="3" >
                <img src={icons.ic_arrow_right} alt="" width="20px" />
            </MoContainer>

            {/* Navbar  */}
            <animated.div style={anim_landingPage[0]} >
                <MoContainer flex h="5.5rem" w="100vw" bg="transparent" pos="absolute" z="1" >
                    {/* Logo */}
                    <MoContainer flex pd={{ l: "4rem" }} align="center">
                        <img height="45px" src={icons.logo2} alt="" />
                    </MoContainer>
                    {/* Links */}
                    <MoContainer gap="2rem" pd={{ r: "4rem", l: "2rem" }} m_l="auto" align="center" flex >
                        <MoLink to="/about-us">About Us</MoLink>
                        <MoSpan pointer f_size="small" onClick={scrollToHowItWorkd} f_w="bold">How It Works</MoSpan>
                        <MoLink col={cols.green} to="/dashboard/home"> {currentUser ? "My Dashboard" : "Sign In"}</MoLink>
                        <MoLink eff_hover="true" b_r={{ all: "5px" }} pd={{ tb: "10px", lr: '15px' }} bg={cols.green} col={cols.mainLight_1} to="/signup">Sign Up</MoLink>
                    </MoContainer>
                </MoContainer>
            </animated.div>

            {/* Home Search */}
            <MoContainer ref={refTopPage} flex flex_dir_c w="100vw" h="100vh" pd={{ t: "5.5rem" }}>
                <MoContainer flex flex_dir_c pd={{ l: "4rem" }}>
                    <MoContainer grid flex_dir_c w="30rem">
                        <animated.div style={anim_landingPage[1]} >
                            <MoSpan col={cols.mainDark_3} f_w="600">Find The Best <span style={{ color: cols.main_blue }}>Tutor</span> For You 💪</MoSpan>
                        </animated.div>
                    </MoContainer>
                    {/* <MoSpan fs_mid col={cols.mainDark_1}> Any Subject, <MoSpan fs_mid> Maths </MoSpan></MoSpan> */}

                    {/* Search */}
                    <animated.div style={anim_landingPage[2]} >

                        <form onSubmit={handleSearch}>
                            <MoContainer flex pd={{ tb: "2rem" }}>
                                <MoContainer sdw={{ sprd: "1rem", op: "rgba(0,0,0,0.15)", x: 0, y: ".8rem" }} pd={{ lr: "1rem", tb: "0rem" }} border={{ w: "1.5px", col: cols.main_purple }} h="5rem" flex align="center" bg={cols.mainLight_4} b_r={{ all: "5rem" }} min_w="25rem">
                                    {/* Subject */}
                                    <MoContainer pos="relative" bg="white" border={{ w: "1.5px", col: cols.main_purple }} pd={{ l: ".7rem", t: ".55rem" }} h="2rem" min-w="10rem" place="center" b_r={{ all: "5rem" }} >
                                        {/* search helper */}
                                        {anim_inputHelperSubject(
                                            (styles, item) => item && <animated.div style={styles} >
                                                <MoContainer flex_c align="center" justify="center" bg={cols.mainLight_4} border={{ w: "1px", col: cols.main_purple }} pos_dir={{ t: "140%" }} b_r={{ all: "10px" }} pos="absolute" w="90%" min_h="6rem" z="3" >
                                                    {domHelperInputSubject}
                                                </MoContainer>
                                            </animated.div>)}
                                        {/* search input */}
                                        <Input onBlur={function () { setInputHelper(prev => ({ ...prev, "isOpenSubjectList": false })) }}
                                            onFocus={function () { setInputHelper(prev => ({ ...prev, "isOpenSubjectList": true })) }}
                                            type="select" onChange={function (e) { handleOnchangeSearch(e); handleInputSubjectHelper() }}
                                            value={subject} name="subject" required border="none" pholder="Subject" icon={icons.ic_search} />
                                    </MoContainer>
                                    {/* Location */}
                                    <MoContainer pos="relative" flex place="center" bg="white" border={{ w: "1.5px", col: cols.main_purple }} pd={{ l: ".7rem", t: ".45rem", b: ".1rem" }} h="2rem" min-w="10rem" b_r={{ all: "5rem" }} >
                                        {/* search helper */}
                                        {anim_inputHelperLocation(
                                            (styles, item) => item && <animated.div style={styles} >
                                                <MoContainer flex_c align="center" justify="center" bg={cols.mainLight_4} border={{ w: "1px", col: cols.main_purple }} pos_dir={{ t: "140%" }} b_r={{ all: "10px" }} pos="absolute" w="90%" min_h="6rem" z="3" >
                                                    {domHelperInputLocation}
                                                </MoContainer>
                                            </animated.div>)}
                                        {/* search input */}
                                        <Input onBlur={function () { setInputHelper(prev => ({ ...prev, "isOpenLocationList": false })) }}
                                            onFocus={function () { setInputHelper(prev => ({ ...prev, "isOpenLocationList": true })) }}
                                            onChange={function (e) { handleOnchangeSearch(e); handleInputLocationHelper() }} value={tutoringAdress} name="tutoringAdress" required border="none" pholder="Location" icon={icons.ic_location} />
                                    </MoContainer>
                                    {/* Search */}
                                    <MoContainer pos="relative" flex align="center">
                                        <MoContainer pos="absolute" pos_dir={{ l: "20px" }}>
                                            <img height="20px" src={icons.ic_bolt_fill} alt="" />

                                        </MoContainer>
                                        <Button pd={{ lr: "3rem" }} type={ButtonTypes.shadowed} b_r="5rem" title="Search" disabled={false} />
                                    </MoContainer>

                                </MoContainer>
                            </MoContainer>
                        </form>
                    </animated.div>
                    <animated.div style={anim_landingPage[3]} >

                        <MoSpan fs_mid col={cols.mainDark_2}> Or <MoLink to="/signup" f_size='1.5rem'> Become a Tutor 🎓 !</MoLink> </MoSpan>
                    </animated.div>
                </MoContainer>

                <MoContainer pos="absolute" w="100%" pos_dir={{ b: "5%" }}>
                    <MoContainer grid place="center">
                        <animated.div style={anim_landingPage[4]} >
                            <MoSpan fs_sml col={cols.mainDark_3}> <MoSpan fs_mid > ” </MoSpan><MoSpan f_size="1rem" f_w="bold" col={cols.main_purple} > An investment in knowledge pays the best interest</MoSpan><MoSpan fs_mid > ” </MoSpan> – Benjamin Franklin </MoSpan>
                        </animated.div>
                    </MoContainer>
                </MoContainer>
            </MoContainer>
            {/* search by */}
            <MoContainer>
                <MoContainer flex justify="center">
                    <Fade left>

                        <MoSpan ref={refHowItWorks} fs_mid f_w="700"> You Can Search By </MoSpan>
                    </Fade>
                </MoContainer>
                <Fade bottom>
                    <MoContainer flex h="15rem" pd={{ all: "2rem" }}>
                        <MoContainer bg="white" eff_shdw={{ op: .2 }} b_r={{ all: ".5rem" }} border={{ w: "1px", col: cols.main_blue }} wh="100%" flex_c align="center">
                            <Alert success w="80%">📚 Subject </Alert>
                            <MoContainer flex wrap="wrap">
                                {domSubjects}
                            </MoContainer>
                        </MoContainer>

                        <MoContainer bg="white" eff_shdw={{ op: .2 }} b_r={{ all: ".5rem" }} border={{ w: "1px", col: cols.main_blue }} wh="100%" flex_c align="center">
                            <Alert success w="80%"> 📍 Location </Alert>
                            <MoContainer flex wrap="wrap">
                                {domLocations}
                            </MoContainer>
                        </MoContainer>

                        <MoContainer bg="white" eff_shdw={{ op: .2 }} b_r={{ all: ".5rem" }} border={{ w: "1px", col: cols.main_blue }} wh="100%" flex_c align="center">
                            <Alert success w="80%"> 💵 Price </Alert>
                            <MoContainer flex_c wrap="wrap">
                                <MoSpan cursor="pointer" fs_sml onClick={function () { handleSearchByPrice(0, 20) }} > Less Than<MoSpan fs_sml col={cols.red}>20 $/h </MoSpan></MoSpan>
                                <MoSpan cursor="pointer" fs_sml onClick={function () { handleSearchByPrice(20, 50) }} > From <MoSpan fs_sml col={cols.red}>20 $/h </MoSpan> To <MoSpan fs_sml col={cols.red}> 50 $/h </MoSpan></MoSpan>
                                <MoSpan cursor="pointer" fs_sml onClick={function () { handleSearchByPrice(50, 9999) }} > More Than <MoSpan fs_sml col={cols.red}>50 $/h </MoSpan></MoSpan>
                            </MoContainer>
                        </MoContainer>



                    </MoContainer>
                </Fade>

            </MoContainer>
            {/* Search Results */}
            {results?.length > 0
                ? <MoContainer ref={refSearchResultContainer} flex flex_dir_c gap="2rem" align="center" pd={{ b: "2rem" }}>
                    <MoContainer flex justify="center">
                        <MoSpan fs_mid f_w="700"> {results?.length}
                            <MoSpan fs_mid f_w="500" col={cols.mainDark_1} > Tutors are available for
                            <MoSpan fs_mid f_w="500" col={cols.red} > you </MoSpan> ! </MoSpan></MoSpan>
                    </MoContainer>
                    {/* Carts Container */}
                    <MoContainer w="90%" flex wrap="wrap" h="fit-content">
                        {/* Carts */}
                        {domSearchResults}
                    </MoContainer>
                </MoContainer>
                : <Fade top><MoContainer>
                    <MoContainer flex justify="center">
                        <MoSpan ref={refHowItWorks} fs_mid f_w="700"> How
                            <MoSpan fs_mid f_w="500" col={cols.mainDark_1} > TutorBolt
                            <MoSpan fs_mid f_w="500" col={cols.red} > Works </MoSpan>  </MoSpan></MoSpan>
                    </MoContainer>
                    <MoContainer flex h="15rem" pd={{ all: "2rem" }}>

                        <MoContainer bg="white" eff_shdw={{ op: .2 }} b_r={{ all: ".5rem" }} border={{ w: "1px", col: cols.main_blue }} wh="100%" flex_c align="center">
                            <Alert info w="80%"> Find </Alert>
                            <MoSpan w="70%" fs_sml col={cols.main_blue} f_w="600" > Find The perfect Tutor For You 🤩</MoSpan>
                        </MoContainer>
                        <MoContainer bg="white" eff_shdw={{ op: .2 }} b_r={{ all: ".5rem" }} border={{ w: "1px", col: cols.main_blue }} wh="100%" flex_c align="center">
                            <Alert info w="80%"> Learn </Alert>
                            <MoSpan w="70%" fs_sml col={cols.main_blue} f_w="600" > Start Your Courses 🤓</MoSpan>
                        </MoContainer>
                        <MoContainer bg="white" eff_shdw={{ op: .2 }} b_r={{ all: ".5rem" }} border={{ w: "1px", col: cols.main_blue }} wh="100%" flex_c align="center">
                            <Alert info w="80%"> Review </Alert>
                            <MoSpan w="70%" fs_sml col={cols.main_blue} f_w="600" > Give A Review To Your Tutor 👍 👎</MoSpan>
                        </MoContainer>


                    </MoContainer>

                </MoContainer></Fade>
            }


        </MoContainer>
    )
}


// <div>
// {results.length > 0 && <p style={{ color: "blue" }}><strong>Results</strong> </p>}
// {results.map((d, i) => <div key={i}>
//     <p >I am {d?.userName}</p>
//     <p >title {d?.title}</p>
//     <p >price : {d?.price}/hour</p>
// </div>)}
// </div>
